/**
 * Custom console commands
 *
 * consoleSuccess('Prueba');
 * consoleError('Prueba');
 * consoleInfo('Prueba');
 * consoleStatus('Prueba', true);
 * consoleStatus('Prueba', false);
 * consoleStatus('Prueba', 'Esto es un texto');
 */

const mainColor = 'hsl(198, 17%, 28%)';
const colorSuccess = 'hsl(94, 52%, 50%)';
const colorError = 'hsl(6, 100%, 60%)';
const colorInfo = 'hsl(198, 7%, 64%)';
const colorText = 'hsl(220, 18%, 97%)';

const consoleSuccess = value => {
  console.log(
    `%c ${value} `,
    `background: ${colorSuccess}; padding: 1px; border-radius: 3px; color: ${colorText};`
  );
};

const consoleError = value => {
  console.log(
    `%c ${value} `,
    `background: ${colorError}; padding: 1px; border-radius: 3px; color: ${colorText};`
  );
};

const consoleInfo = value => {
  console.log(
    `%c ${value} `,
    `background: ${colorInfo}; padding: 1px; border-radius: 3px; color: ${colorText};`
  );
};

const consoleStatus = (title, value) => {
  let color;

  switch (value) {
    case true:
      color = colorSuccess;
      value = 'true ';
      break;
    case false:
      color = colorError;
      value = 'false';
      break;
    default:
      color = colorInfo;
      break;
  }

  console.log(
    `%c ${title} %c ${value} `,
    `background: ${mainColor}; padding: 1px; border-radius: 3px 0 0 3px; color: ${colorText};`,
    `background: ${color}; padding: 1px; border-radius: 0 3px 3px 0; color: ${colorText};`
  );
};

export { consoleSuccess, consoleError, consoleInfo, consoleStatus };
